import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "../../utils/apis";

export const addEntityFavorite = createAsyncThunk(
  "collectorInvites/addFavorite",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const rsp = await API.postApi(`Donation/AddFavorites`, data, {}, token);
      return rsp.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

export const getEntityFavorites = createAsyncThunk(
  "collectorInvites/getEntityFavorites",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const rsp = await API.getApi(
        `Donation/GetFavoritEntities/${data.entityId}/${data.status}/${data.isBlacklist}`,
        {},
        token
      );
      return rsp.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

export const getCollectorInviteForDonation = createAsyncThunk(
  "collectorInvites/getCollectorInviteForDonation",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const rsp = await API.postApi(
        `Collection/GetCollectionInvite/${data.donationId}`,
        {},
        { collectorEntityId: data?.collectorEntityId },
        token
      );
      return rsp.data;
    } catch (error) {
     // console.error(error);
      //throw error;
    }
  }
);

const initialState = {
  loading: false,
  status: "idle",
  entityFavorite: {},
  entitiesFavorites: [],
  collectorInviteForDonation: {},
};

export const collectorInviteSlice = createSlice({
  name: "collectorInvites",
  initialState: initialState,
  reducers: {
    resetCollectorInvite: (state) => {
      state = initialState;
    },
    // setDocumentOffset: (state, action) => {
    //   state.entitiesOffset = action.payload;
    // },
    // setDocumentLimit: (state, action) => {
    //   state.entitiesLimit = action.payload;
    // },
    // setDocumentPage: (state, action) => {
    //   state.entitiesPage = action.payload;
    // },
    // setConfirmationDocumentDialog: (state, action) => {
    //   state.confirmationDocumentDialog = action.payload;
    // },
    // setInvalidDocumentData: (state, action) => {
    //   state.invalidDocument = action.payload;
    // },
    // setInvalidDocument: (state, action) => {
    //   state.invalidDocument = action.payload;
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addEntityFavorite.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(addEntityFavorite.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.entityFavorite = action.payload;
      })
      .addCase(addEntityFavorite.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.entityFavorite = {};
      })
      .addCase(getEntityFavorites.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(getEntityFavorites.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.entitiesFavorites = action.payload.favorites;
      })
      .addCase(getEntityFavorites.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.entitiesFavorites = [];
      })
      .addCase(getCollectorInviteForDonation.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(getCollectorInviteForDonation.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.collectorInviteForDonation = action.payload;
      })
      .addCase(getCollectorInviteForDonation.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
      });
  },
});

// export const {
//   setDocumentOffset,
//   setDocumentLimit,
//   setDocumentPage,
//   setInvalidDocumentData,
//   setInvalidDocument,
//   setConfirmationDocumentDialog
// } = documentDetailsSlice.actions

export default collectorInviteSlice.reducer;
